import React, { createContext, useContext } from 'react';

const SitemapContext = createContext([]);

export const SitemapProvider = ({ children }) => {
	return <SitemapContext.Provider value={JSON.parse(process.env.GATSBY_SITEMAP)}>{children}</SitemapContext.Provider>;
};

export const useSitemap = () => {
	return useContext(SitemapContext);
};
